// extracted by mini-css-extract-plugin
export default {"inlineAdWrapper":"BV-z","inlineTitle":"CV-z","sponsoredAdsWrapper":"DV-z","marketplaceRecosWrapper":"EV-z"};